module.exports = __webpack_public_path__ + "static/img/2_1_2.85651a1a.jpg";